import { Box, Typography } from "@mui/material";

export type VerifyTone = "neutral" | "notice";

// Deliberately no tick, cross or pass/fail colour. A glyph of that kind reads
// as a judgement on the paper in the reader's hand, which this page has no
// basis to make -- it can only show what was stored.
const VerifyVerdict = ({
  title,
  body,
  tone = "neutral",
}: {
  title: string;
  body: string;
  tone?: VerifyTone;
}) => (
  <Box
    role="status"
    sx={theme => ({
      p: "20px 22px",
      mb: 1,
      borderRadius: "10px",
      border: "1px solid",
      borderColor:
        tone === "notice"
          ? theme.palette.warning.light
          : theme.palette.divider,
      backgroundColor:
        tone === "notice"
          ? theme.palette.warning.light + "22"
          : theme.palette.action.hover,
    })}
  >
    <Typography
      component="h2"
      sx={theme => ({
        fontSize: "17px",
        fontWeight: 700,
        mb: 0.6,
        color: theme.palette.text.primary,
      })}
    >
      {title}
    </Typography>
    <Typography
      sx={theme => ({
        fontSize: "14px",
        lineHeight: 1.6,
        color: theme.palette.text.secondary,
      })}
    >
      {body}
    </Typography>
  </Box>
);

export default VerifyVerdict;
